/**
 * @generated SignedSource<<dbeaad62dd605afbbd0d837cd5dfbce6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "NEW" | "PENDING" | "DELETED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type userTracking_user$data = {
  readonly createdDate: string | null;
  readonly isVip: boolean | null;
  readonly isVerifiedTrade: boolean | null;
  readonly verifiedTradeStatus: string | null;
  readonly authMetadata: {
    readonly emailOnly: boolean | null;
    readonly hasPassword: boolean | null;
  } | null;
  readonly profile: {
    readonly email: string | null;
    readonly zipCode: string | null;
  } | null;
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly serviceId: string | null;
  readonly totalMessagesToDealers: number | null;
  readonly tradeFirm: {
    readonly serviceId: string | null;
    readonly profileStatus: DesignProfileStatus | null;
    readonly rewards: {
      readonly currentProgram: {
        readonly programInfo: {
          readonly code: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly mentionMeTagParameters: {
    readonly ciphertext: string | null;
    readonly nonce: string | null;
  } | null;
  readonly activePromotion: {
    readonly campaignName: string | null;
    readonly buyerDisplayable: boolean | null;
  } | null;
  readonly " $fragmentType": "userTracking_user";
};
export type userTracking_user$key = {
  readonly " $data"?: userTracking_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"userTracking_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVip",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verifiedTradeStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "kind": "LinkedField",
      "name": "authMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailOnly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPassword",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zipCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalMessagesToDealers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "kind": "LinkedField",
      "name": "tradeFirm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmRewards",
          "kind": "LinkedField",
          "name": "rewards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ParentProgram",
              "kind": "LinkedField",
              "name": "currentProgram",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LoyaltyProgram",
                  "kind": "LinkedField",
                  "name": "programInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "mentionMeTagParameters",
      "kind": "LinkedField",
      "name": "mentionMeTagParameters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ciphertext",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nonce",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "campaignName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buyerDisplayable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "d1fd54253822755c8329db4c30582dbe";

export default node;
